import { useFormRowContext } from './FormRowContext';

export const IdCell = () => {
  const {
    form: { id },
  } = useFormRowContext();

  return <td>{id}</td>;
};
